export default {
  'selected-count': '{{count}} selected',
  title: 'E-Leave - Leave Approval',
  form: {
    organization: {
      placeholder: 'Oc Name..',
      label: 'Oc Name'
    },
    'employee-code': {
      placeholder: 'Employee Code..',
      label: 'Employee Code'
    },
    'name-surname': {
      placeholder: 'Name - Surname..',
      label: 'Name - Surname'
    },
    position: {
      placeholder: 'Position..',
      label: 'Position'
    },
    level: {
      placeholder: 'Level..',
      label: 'Level'
    },
    status: {
      placeholder: 'Status..',
      label: 'Status'
    },
    'leave-status': {
      placeholder: 'Leave Status..',
      label: 'Leave Status'
    },
    date: {
      placeholder: 'Date..',
      label: 'Date'
    },
    'leave-type': {
      placeholder: 'Select All',
      label: 'Leave Type'
    }
  },
  table: {
    name: 'Name - Surname',
    type: 'Leave Type',
    duration: 'Leave Duration',
    days: 'No. of Days',
    reason: 'Reason',
    status: 'Status',
    approval: 'Apporval Persons',
    attach: 'Attach',
    detail: 'Detail',
    action: 'Action',
    title: 'Title',
    otdays: 'OT Days',
    otduration: 'Duration',
    date: 'Date',
    remark: 'Remark',
    requester: 'Requester'
  },
  modal: {
    detail: 'Leave Request Detail',
    approve: 'Are you sure want to Approve ?',
    reject: 'Are you sure want to Reject ?'
  }
}
